import dayjs from "dayjs";

import { Data } from "./Table/types";

import { IPaymentItem } from "@/api/types/payments";

function formatPlanMoney(value: number | string | null | undefined, currency: string): string {
    if (value === null || value === undefined || value === "") return "-";
    const num = typeof value === "string" ? parseFloat(value) : Number(value);
    if (Number.isNaN(num)) return "-";
    return `${num.toFixed(2)} ${currency}`;
}

/** List / subscription plan price from API (not necessarily equal to charged amount). */
function getPlanPriceDisplay(data: IPaymentItem, fallbackCurrency: string): string {
    const raw = data as unknown as Record<string, unknown>;
    const sub = raw.subscription as { amount?: number | string, currency?: string } | undefined;

    if (sub?.amount !== undefined && sub?.amount !== null && sub?.amount !== "") {
        return formatPlanMoney(sub.amount, sub.currency || fallbackCurrency || "-");
    }

    const planInfo = raw.planInfo as { price?: number, currency?: string } | undefined;
    if (planInfo?.price != null && !Number.isNaN(Number(planInfo.price))) {
        return formatPlanMoney(planInfo.price, planInfo.currency || fallbackCurrency || "-");
    }

    const plan = raw.plan as { price?: number, currency?: string } | undefined;
    if (plan?.price != null && !Number.isNaN(Number(plan.price))) {
        return formatPlanMoney(plan.price, plan.currency || fallbackCurrency || "-");
    }

    return "-";
}

export function createData(data: IPaymentItem): Data {
    const {
        id,
        userId,
        planName,
        paidAt,
        status,
        amount,
        currency,
        createdAt,
        method,
        customer,
        data: transactionData,
        detail,
    } = data;

    // Format the paidAt date, fallback to createdAt if paidAt is not available
    const formattedDate = paidAt ? dayjs(paidAt).format("YYYY-MM-DD HH:mm") : dayjs(createdAt).format("YYYY-MM-DD HH:mm");

    // Get customer email from user object (new API structure) or customer object (fallback)
    // Using type assertion since the interface might be outdated
    const customerEmail = (data as any)?.user?.email || customer?.email || "-";

    // Get payment method from multiple sources
    const paymentMethod = method || detail?.paymentMethod?.method || "-";

    // Get payment source from detail object
    const paymentSource = detail?.paymentMethod?.paymentSource || "-";

    // Get amount from multiple sources
    const finalAmount = amount || transactionData?.amount || 0;

    // Get currency from multiple sources
    const finalCurrency = currency || transactionData?.currency || "-";

    return {
        id: id || 0,
        userId: userId || 0,
        customerEmail: customerEmail,
        status: status || transactionData?.status || "-",
        amount: finalAmount,
        currency: finalCurrency,
        planPrice: getPlanPriceDisplay(data, finalCurrency),
        planName: planName || "-",
        paidAt: formattedDate,
        method: paymentMethod,
        paymentSource: paymentSource,
    };
}
